/**
 * @license
 * Copyright (c) 2017, Barclays Africa Technology, All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file
 */

import { Action } from '@ngrx/store';
import { Experience } from '../../models/experience';

export const SET_EXPERIENCE = '[THRESHOLD EXPERIENCE APP] Set Threshold Experience App';

export const LOAD_EXPERIENCE = '[THRESHOLD APP EXPERIENCE] Load experience';
export const LOAD_EXPERIENCE_SUCCESS = '[THRESHOLD APP EXPERIENCE] Load experience success';
export const LOAD_EXPERIENCE_FAIL = '[THRESHOLD APP EXPERIENCE] Load experience fail';

export class LoadExperienceAction implements Action {
    readonly type = LOAD_EXPERIENCE;
    constructor(public payload: Experience[]) {}
}

export class LoadExperienceSuccessAction implements Action 
{ 
    readonly type = LOAD_EXPERIENCE_SUCCESS
}

// export class SetExperienceAction implements Action {
//     readonly type = SET_EXPERIENCE;
//     constructor(public payload: Experience[]) {}
// }

export type Actions = LoadExperienceAction | LoadExperienceSuccessAction;


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./~/angular-router-loader/src!./src/app/threshold/store/actions/experience.actions.ts